import { onError } from '@apollo/client/link/error';
import type { Operation } from '@apollo/client/link/core';

import { promiseToObservable } from '../../util';
import { AuthenticationPlugin } from '../../plugin';

interface StalledTask {
    operation: Operation
    resolve: (value: unknown) => void
    reject: (reason?: any) => void
}

let isRefreshing = false;
let stalledTasks = new Set<StalledTask>();

function createRefreshTokenHandler(authPlugin: AuthenticationPlugin){

    const executeRefresh = async () => {

        isRefreshing = true;

        try {

            const session = await authPlugin.refreshToken()

            for(let task of stalledTasks){

                const currentHeaders = task.operation.getContext()?.headers;

                task.operation.setContext({
                    headers: {
                        ...(currentHeaders || {}),
                        Authorization: `Bearer ${session.token}`
                    }
                });

                task.resolve(task.operation);
            }
        }
        catch(e){

            setTimeout(() => {
                authPlugin.logout();
            }, 100);
        }
        finally {

            stalledTasks.clear();

            isRefreshing = false;
        }
    };

    return (networkError, operation, forward) => {

        if (networkError && networkError.statusCode === 401) {

            const returnPromise = new Promise((resolve, reject) => {

                stalledTasks.add({
                    operation, resolve, reject
                });
            });

            if(!isRefreshing){
                executeRefresh();
            }

            return promiseToObservable(returnPromise).flatMap(forward);
        }
    }
}

export function createRefreshTokenLink(authPlugin: AuthenticationPlugin){

    const refreshTokenHandler = createRefreshTokenHandler(authPlugin);

    return onError(({ networkError, forward, operation }) => refreshTokenHandler(networkError, operation, forward));
}

export default createRefreshTokenLink;